import React, { useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Clock, ArrowRight, RefreshCcw } from "lucide-react";

export function PaymentSuccess() {
  const { refreshUser } = useAuth();
  const nav = useNavigate();
  useEffect(() => { refreshUser?.(); }, []); // eslint-disable-line
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0f0a08] px-6 text-white" style={{ fontFamily: "'Cormorant Garamond', serif" }} data-testid="payment-success">
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,400&family=Inter:wght@400;500;600;700&display=swap" />
      <div className="max-w-md text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500/15">
          <CheckCircle2 className="h-10 w-10 text-emerald-400" />
        </div>
        <h1 className="mt-6 text-5xl italic" style={{ fontFamily: "'Great Vibes', cursive", color: "#e6c98a" }}>Pembayaran Berhasil</h1>
        <p className="mt-4 text-neutral-300" style={{ fontFamily: "'Inter', sans-serif" }}>
          Terima kasih! Paket Anda telah aktif. Silakan lanjut mengakses seluruh fitur Wedifylab.
        </p>
        <Button data-testid="success-goto-app" onClick={() => nav("/app")}
          className="mt-8 gap-2 rounded-full px-8 py-6 text-[#0f0a08]" style={{ background: "linear-gradient(90deg,#c9a35c,#e6c98a)", fontFamily: "'Inter', sans-serif" }}>
          Ke Dashboard <ArrowRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}

export function PaymentFailed() {
  const nav = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0f0a08] px-6 text-white" style={{ fontFamily: "'Cormorant Garamond', serif" }} data-testid="payment-failed">
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,400&family=Inter:wght@400;500;600;700&display=swap" />
      <div className="max-w-md text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-red-500/15">
          <XCircle className="h-10 w-10 text-red-400" />
        </div>
        <h1 className="mt-6 text-5xl italic" style={{ fontFamily: "'Great Vibes', cursive", color: "#e6c98a" }}>Pembayaran Gagal</h1>
        <p className="mt-4 text-neutral-300" style={{ fontFamily: "'Inter', sans-serif" }}>
          Maaf, pembayaran tidak dapat diproses atau dibatalkan. Silakan coba lagi dengan metode pembayaran yang berbeda.
        </p>
        <div className="mt-8 flex flex-col items-center gap-3">
          <Button data-testid="failed-retry" onClick={() => nav("/paket")}
            className="gap-2 rounded-full px-8 py-6 text-[#0f0a08]" style={{ background: "linear-gradient(90deg,#c9a35c,#e6c98a)", fontFamily: "'Inter', sans-serif" }}>
            <RefreshCcw className="h-4 w-4" /> Coba Lagi
          </Button>
          <Link to="/app" className="text-xs text-neutral-500 hover:text-neutral-300" style={{ fontFamily: "'Inter', sans-serif" }}>Kembali ke aplikasi</Link>
        </div>
      </div>
    </div>
  );
}

export function PaymentPending() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0f0a08] px-6 text-white" style={{ fontFamily: "'Cormorant Garamond', serif" }} data-testid="payment-pending">
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,400&family=Inter:wght@400;500;600;700&display=swap" />
      <div className="max-w-md text-center">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-yellow-500/15">
          <Clock className="h-10 w-10 text-yellow-400" />
        </div>
        <h1 className="mt-6 text-5xl italic" style={{ fontFamily: "'Great Vibes', cursive", color: "#e6c98a" }}>Menunggu Pembayaran</h1>
        <p className="mt-4 text-neutral-300" style={{ fontFamily: "'Inter', sans-serif" }}>
          Silakan selesaikan pembayaran sesuai instruksi. Paket Anda akan aktif otomatis setelah pembayaran dikonfirmasi oleh Midtrans (biasanya dalam beberapa menit).
        </p>
        <Link to="/paket"><Button className="mt-8 rounded-full">Kembali ke Halaman Paket</Button></Link>
      </div>
    </div>
  );
}
